[
  {
    "id": "rusty_sword",
    "name": "Rusty Sword",
    "kind": "weapon",
    "slot": "weapon",
    "levelReq": 1,
    "value": 12,
    "classes": ["warrior"],
    "stats": {
      "ap": 12,
      "str": 1,
      "hp": 6
    },
    "icon": "sword",
    "tier": 0
  },
  {
    "id": "iron_sword",
    "name": "Iron Sword",
    "kind": "weapon",
    "slot": "weapon",
    "levelReq": 5,
    "value": 60,
    "classes": ["warrior"],
    "stats": {
      "ap": 18,
      "str": 2,
      "hp": 12
    },
    "icon": "sword",
    "tier": 1
  },
  {
    "id": "iron_hatchet",
    "name": "Iron Hatchet",
    "kind": "weapon",
    "slot": "weapon",
    "levelReq": 5,
    "value": 65,
    "classes": ["warrior"],
    "stats": {
      "ap": 19,
      "str": 2,
      "hp": 12
    },
    "icon": "axe",
    "tier": 1
  },
  {
    "id": "worn_daggers",
    "name": "Worn Daggers",
    "kind": "weapon",
    "slot": "weapon",
    "levelReq": 1,
    "value": 12,
    "classes": ["rogue"],
    "stats": {
      "ap": 10,
      "dex": 1,
      "hp": 4
    },
    "icon": "daggers",
    "tier": 0
  },
  {
    "id": "iron_daggers",
    "name": "Iron Daggers",
    "kind": "weapon",
    "slot": "weapon",
    "levelReq": 5,
    "value": 60,
    "classes": ["rogue"],
    "stats": {
      "ap": 15,
      "dex": 2,
      "hp": 8
    },
    "icon": "daggers",
    "tier": 1
  },
  {
    "id": "ash_staff",
    "name": "Ash Staff",
    "kind": "weapon",
    "slot": "weapon",
    "levelReq": 1,
    "value": 12,
    "classes": ["mage"],
    "stats": {
      "ap": 10,
      "mp": 10,
      "int": 1
    },
    "icon": "staff",
    "tier": 0
  },
  {
    "id": "oak_staff",
    "name": "Oak Staff",
    "kind": "weapon",
    "slot": "weapon",
    "levelReq": 5,
    "value": 60,
    "classes": ["mage"],
    "stats": {
      "ap": 15,
      "mp": 20,
      "int": 2
    },
    "icon": "staff",
    "tier": 1
  },
  {
    "id": "wooden_mace",
    "name": "Wooden Mace",
    "kind": "weapon",
    "slot": "weapon",
    "levelReq": 1,
    "value": 12,
    "classes": ["priest"],
    "stats": {
      "ap": 11,
      "mp": 5,
      "int": 1,
      "vit": 1
    },
    "icon": "mace",
    "tier": 0
  },
  {
    "id": "iron_mace",
    "name": "Iron Mace",
    "kind": "weapon",
    "slot": "weapon",
    "levelReq": 5,
    "value": 60,
    "classes": ["priest"],
    "stats": {
      "ap": 16,
      "mp": 10,
      "int": 2,
      "vit": 1
    },
    "icon": "mace",
    "tier": 1
  },
  {
    "id": "wooden_shield",
    "name": "Wooden Shield",
    "kind": "armor",
    "slot": "offhand",
    "levelReq": 1,
    "value": 10,
    "classes": ["warrior", "priest"],
    "stats": {
      "def": 2,
      "hp": 8,
      "vit": 1
    },
    "icon": "shield",
    "tier": 0
  },
  {
    "id": "iron_shield",
    "name": "Iron Shield",
    "kind": "armor",
    "slot": "offhand",
    "levelReq": 5,
    "value": 55,
    "classes": ["warrior", "priest"],
    "stats": {
      "def": 4,
      "hp": 16,
      "vit": 1
    },
    "icon": "shield",
    "tier": 1
  },
  {
    "id": "leather_cap",
    "name": "Leather Cap",
    "kind": "armor",
    "slot": "head",
    "levelReq": 1,
    "value": 6,
    "stats": {
      "def": 1,
      "hp": 5,
      "mp": 5
    },
    "icon": "helm",
    "tier": 0
  },
  {
    "id": "padded_vest",
    "name": "Padded Vest",
    "kind": "armor",
    "slot": "chest",
    "levelReq": 1,
    "value": 10,
    "stats": {
      "def": 2,
      "hp": 8,
      "vit": 1
    },
    "icon": "chest",
    "tier": 0
  },
  {
    "id": "leather_gloves",
    "name": "Leather Gloves",
    "kind": "armor",
    "slot": "hands",
    "levelReq": 1,
    "value": 5,
    "stats": {
      "def": 1,
      "ap": 2
    },
    "icon": "gloves",
    "tier": 0
  },
  {
    "id": "leather_boots",
    "name": "Leather Boots",
    "kind": "armor",
    "slot": "feet",
    "levelReq": 1,
    "value": 6,
    "stats": {
      "def": 1,
      "hp": 5,
      "dex": 1
    },
    "icon": "boots",
    "tier": 0
  },
  {
    "id": "iron_helm",
    "name": "Iron Helm",
    "kind": "armor",
    "slot": "head",
    "levelReq": 5,
    "value": 40,
    "stats": {
      "def": 2,
      "hp": 10,
      "vit": 1
    },
    "icon": "helm",
    "classes": ["warrior"],
    "tier": 1
  },
  {
    "id": "chain_vest",
    "name": "Chain Vest",
    "kind": "armor",
    "slot": "chest",
    "levelReq": 5,
    "value": 70,
    "stats": {
      "def": 4,
      "hp": 16,
      "vit": 1
    },
    "icon": "chest",
    "classes": ["warrior"],
    "tier": 1
  },
  {
    "id": "iron_gauntlets",
    "name": "Iron Gauntlets",
    "kind": "armor",
    "slot": "hands",
    "levelReq": 5,
    "value": 35,
    "stats": {
      "def": 2,
      "ap": 3,
      "str": 1
    },
    "icon": "gloves",
    "classes": ["warrior"],
    "tier": 1
  },
  {
    "id": "iron_boots",
    "name": "Iron Boots",
    "kind": "armor",
    "slot": "feet",
    "levelReq": 5,
    "value": 40,
    "stats": {
      "def": 2,
      "hp": 10,
      "str": 1
    },
    "icon": "boots",
    "classes": ["warrior"],
    "tier": 1
  },
  {
    "id": "copper_ring",
    "name": "Copper Ring",
    "kind": "accessory",
    "slot": "ring",
    "levelReq": 3,
    "value": 30,
    "stats": {
      "hp": 15,
      "str": 1
    },
    "icon": "ring"
  },
  {
    "id": "bone_necklace",
    "name": "Bone Necklace",
    "kind": "accessory",
    "slot": "neck",
    "levelReq": 3,
    "value": 35,
    "stats": {
      "mp": 20,
      "int": 1
    },
    "icon": "necklace"
  },
  {
    "id": "minor_hp_potion",
    "retired": true,
    "name": "Minor Healing Potion",
    "kind": "consumable",
    "slot": "none",
    "levelReq": 1,
    "value": 5,
    "stats": {},
    "stack": 20,
    "use": {
      "hp": 90,
      "cooldownMs": 10000
    },
    "icon": "potion_hp"
  },
  {
    "id": "minor_mp_potion",
    "retired": true,
    "name": "Minor Mana Potion",
    "kind": "consumable",
    "slot": "none",
    "levelReq": 1,
    "value": 5,
    "stats": {},
    "stack": 20,
    "use": {
      "mp": 70,
      "cooldownMs": 10000
    },
    "icon": "potion_mp"
  },
  {
    "id": "boar_hide",
    "name": "Boar Hide",
    "kind": "material",
    "slot": "none",
    "levelReq": 1,
    "value": 2,
    "stats": {},
    "stack": 50,
    "icon": "hide"
  },
  {
    "id": "wolf_fang",
    "name": "Wolf Fang",
    "kind": "material",
    "slot": "none",
    "levelReq": 1,
    "value": 3,
    "stats": {},
    "stack": 50,
    "icon": "fang"
  },
  {
    "id": "toad_slime",
    "name": "Toad Slime",
    "kind": "material",
    "slot": "none",
    "levelReq": 1,
    "value": 4,
    "stats": {},
    "stack": 50,
    "icon": "slime"
  },
  {
    "id": "husk_stone",
    "name": "Husk Stone",
    "kind": "material",
    "slot": "none",
    "levelReq": 1,
    "value": 8,
    "stats": {},
    "stack": 50,
    "icon": "stone"
  },
  {
    "id": "upgrade_scroll",
    "name": "Upgrade Scroll",
    "kind": "scroll",
    "slot": "none",
    "levelReq": 1,
    "value": 5000,
    "stats": {},
    "stack": 50,
    "scroll": "gear",
    "icon": "scroll_mid"
  },
  {
    "id": "colony_scroll",
    "name": "Best Upgrade Scroll",
    "kind": "scroll",
    "slot": "none",
    "levelReq": 1,
    "value": 1000000,
    "stats": {},
    "scroll": "gear",
    "successMult": 1.5,
    "icon": "scroll_colony"
  },
  {
    "id": "jewelry_scroll",
    "name": "Jewelry Scroll",
    "kind": "scroll",
    "slot": "none",
    "levelReq": 1,
    "value": 20000,
    "stats": {},
    "stack": 50,
    "scroll": "jewelry",
    "icon": "scroll_high"
  },
  {
    "id": "fortune_stone",
    "name": "Fortune Stone",
    "kind": "scroll",
    "slot": "none",
    "levelReq": 1,
    "value": 0,
    "stats": {},
    "stack": 50,
    "scroll": "fortune",
    "icon": "fortune_stone"
  },
  {
    "id": "steel_sword",
    "name": "Steel Sword",
    "kind": "weapon",
    "slot": "weapon",
    "levelReq": 15,
    "value": 250,
    "classes": ["warrior"],
    "stats": {
      "ap": 34,
      "str": 4,
      "hp": 24
    },
    "icon": "sword",
    "tier": 2
  },
  {
    "id": "steel_falchion",
    "name": "Steel Falchion",
    "kind": "weapon",
    "slot": "weapon",
    "levelReq": 15,
    "value": 260,
    "classes": ["warrior"],
    "stats": {
      "ap": 35,
      "str": 4,
      "hp": 24
    },
    "icon": "falchion",
    "tier": 2
  },
  {
    "id": "steel_daggers",
    "name": "Steel Daggers",
    "kind": "weapon",
    "slot": "weapon",
    "levelReq": 15,
    "value": 250,
    "classes": ["rogue"],
    "stats": {
      "ap": 29,
      "dex": 4,
      "hp": 16
    },
    "icon": "daggers",
    "tier": 2
  },
  {
    "id": "steel_venom_daggers",
    "name": "Venom Daggers",
    "kind": "weapon",
    "slot": "weapon",
    "levelReq": 15,
    "value": 270,
    "classes": ["rogue"],
    "stats": {
      "ap": 29,
      "dex": 4,
      "hp": 16
    },
    "icon": "daggers",
    "element": "poison",
    "elementDmg": 4,
    "tier": 2
  },
  {
    "id": "steel_staff",
    "name": "Ironwood Staff",
    "kind": "weapon",
    "slot": "weapon",
    "levelReq": 15,
    "value": 250,
    "classes": ["mage"],
    "stats": {
      "ap": 29,
      "mp": 40,
      "int": 4
    },
    "icon": "staff",
    "tier": 2
  },
  {
    "id": "steel_mace",
    "name": "Steel Mace",
    "kind": "weapon",
    "slot": "weapon",
    "levelReq": 15,
    "value": 250,
    "classes": ["priest"],
    "stats": {
      "ap": 31,
      "mp": 20,
      "int": 3,
      "vit": 2
    },
    "icon": "mace",
    "tier": 2
  },
  {
    "id": "steel_shield",
    "name": "Steel Shield",
    "kind": "armor",
    "slot": "offhand",
    "levelReq": 15,
    "value": 225,
    "classes": ["warrior", "priest"],
    "stats": {
      "def": 8,
      "hp": 40,
      "vit": 2
    },
    "icon": "shield",
    "tier": 2
  },
  {
    "id": "steel_helm",
    "name": "Steel Helm",
    "kind": "armor",
    "slot": "head",
    "levelReq": 15,
    "value": 175,
    "stats": {
      "def": 5,
      "hp": 25,
      "vit": 2
    },
    "icon": "helm",
    "classes": ["warrior"],
    "tier": 2
  },
  {
    "id": "steel_plate",
    "name": "Steel Plate",
    "kind": "armor",
    "slot": "chest",
    "levelReq": 15,
    "value": 275,
    "stats": {
      "def": 9,
      "hp": 40,
      "vit": 2
    },
    "icon": "chest",
    "classes": ["warrior"],
    "tier": 2
  },
  {
    "id": "steel_gauntlets",
    "name": "Steel Gauntlets",
    "kind": "armor",
    "slot": "hands",
    "levelReq": 15,
    "value": 150,
    "stats": {
      "def": 4,
      "ap": 6,
      "str": 1
    },
    "icon": "gloves",
    "classes": ["warrior"],
    "tier": 2
  },
  {
    "id": "steel_boots",
    "name": "Steel Boots",
    "kind": "armor",
    "slot": "feet",
    "levelReq": 15,
    "value": 150,
    "stats": {
      "def": 4,
      "hp": 20,
      "str": 2
    },
    "icon": "boots",
    "classes": ["warrior"],
    "tier": 2
  },
  {
    "id": "mithril_sword",
    "name": "Mithril Sword",
    "kind": "weapon",
    "slot": "weapon",
    "levelReq": 30,
    "value": 900,
    "classes": ["warrior"],
    "stats": {
      "ap": 60,
      "str": 7,
      "hp": 42
    },
    "icon": "sword",
    "tier": 3
  },
  {
    "id": "mithril_waraxe",
    "name": "Mithril Waraxe",
    "kind": "weapon",
    "slot": "weapon",
    "levelReq": 30,
    "value": 930,
    "classes": ["warrior"],
    "stats": {
      "ap": 62,
      "str": 7,
      "hp": 42
    },
    "icon": "axe",
    "twoHanded": true,
    "tier": 3
  },
  {
    "id": "mithril_daggers",
    "name": "Mithril Daggers",
    "kind": "weapon",
    "slot": "weapon",
    "levelReq": 30,
    "value": 900,
    "classes": ["rogue"],
    "stats": {
      "ap": 51,
      "dex": 7,
      "hp": 28
    },
    "icon": "daggers",
    "tier": 3
  },
  {
    "id": "mithril_rime_daggers",
    "name": "Rime Daggers",
    "kind": "weapon",
    "slot": "weapon",
    "levelReq": 30,
    "value": 960,
    "classes": ["rogue"],
    "stats": {
      "ap": 51,
      "dex": 7,
      "hp": 28
    },
    "icon": "daggers",
    "element": "ice",
    "elementDmg": 6,
    "tier": 3
  },
  {
    "id": "mithril_staff",
    "name": "Mithril Staff",
    "kind": "weapon",
    "slot": "weapon",
    "levelReq": 30,
    "value": 900,
    "classes": ["mage"],
    "stats": {
      "ap": 51,
      "mp": 70,
      "int": 7
    },
    "icon": "staff",
    "tier": 3
  },
  {
    "id": "mithril_mace",
    "name": "Mithril Mace",
    "kind": "weapon",
    "slot": "weapon",
    "levelReq": 30,
    "value": 900,
    "classes": ["priest"],
    "stats": {
      "ap": 54,
      "mp": 35,
      "int": 5,
      "vit": 4
    },
    "icon": "mace",
    "tier": 3
  },
  {
    "id": "mithril_shield",
    "name": "Mithril Shield",
    "kind": "armor",
    "slot": "offhand",
    "levelReq": 30,
    "value": 810,
    "classes": ["warrior", "priest"],
    "stats": {
      "def": 14,
      "hp": 70,
      "vit": 4
    },
    "icon": "shield",
    "tier": 3
  },
  {
    "id": "mithril_helm",
    "name": "Mithril Helm",
    "kind": "armor",
    "slot": "head",
    "levelReq": 30,
    "value": 630,
    "stats": {
      "def": 9,
      "hp": 44,
      "vit": 3
    },
    "icon": "helm",
    "classes": ["warrior"],
    "tier": 3
  },
  {
    "id": "mithril_plate",
    "name": "Mithril Plate",
    "kind": "armor",
    "slot": "chest",
    "levelReq": 30,
    "value": 990,
    "stats": {
      "def": 16,
      "hp": 70,
      "vit": 4
    },
    "icon": "chest",
    "classes": ["warrior"],
    "tier": 3
  },
  {
    "id": "mithril_gauntlets",
    "name": "Mithril Gauntlets",
    "kind": "armor",
    "slot": "hands",
    "levelReq": 30,
    "value": 540,
    "stats": {
      "def": 7,
      "ap": 10,
      "str": 2
    },
    "icon": "gloves",
    "classes": ["warrior"],
    "tier": 3
  },
  {
    "id": "mithril_boots",
    "name": "Mithril Boots",
    "kind": "armor",
    "slot": "feet",
    "levelReq": 30,
    "value": 540,
    "stats": {
      "def": 7,
      "hp": 35,
      "str": 4
    },
    "icon": "boots",
    "classes": ["warrior"],
    "tier": 3
  },
  {
    "id": "dragon_sword",
    "name": "Dragon Sword",
    "kind": "weapon",
    "slot": "weapon",
    "levelReq": 45,
    "value": 3000,
    "classes": ["warrior"],
    "stats": {
      "ap": 92,
      "str": 10,
      "hp": 60
    },
    "icon": "sword",
    "element": "fire",
    "elementDmg": 8,
    "tier": 4
  },
  {
    "id": "dragon_wingblade",
    "name": "Dragon Wingblade",
    "kind": "weapon",
    "slot": "weapon",
    "levelReq": 45,
    "value": 3100,
    "classes": ["warrior"],
    "stats": {
      "ap": 94,
      "str": 10,
      "hp": 60
    },
    "icon": "wingblade",
    "element": "fire",
    "elementDmg": 8,
    "twoHanded": true,
    "tier": 4
  },
  {
    "id": "dragon_scythe",
    "name": "Dragon Scythe",
    "kind": "weapon",
    "slot": "weapon",
    "levelReq": 45,
    "value": 3200,
    "classes": ["warrior"],
    "stats": {
      "ap": 96,
      "hp": 60,
      "str": 10
    },
    "icon": "scythe",
    "element": "fire",
    "elementDmg": 8,
    "twoHanded": true,
    "tier": 4
  },
  {
    "id": "dragon_daggers",
    "name": "Dragon Daggers",
    "kind": "weapon",
    "slot": "weapon",
    "levelReq": 45,
    "value": 3000,
    "classes": ["rogue"],
    "stats": {
      "ap": 78,
      "dex": 10,
      "hp": 40
    },
    "icon": "daggers",
    "element": "fire",
    "elementDmg": 7,
    "tier": 4
  },
  {
    "id": "dragon_storm_daggers",
    "name": "Stormfang Daggers",
    "kind": "weapon",
    "slot": "weapon",
    "levelReq": 45,
    "value": 3200,
    "classes": ["rogue"],
    "stats": {
      "ap": 78,
      "dex": 10,
      "hp": 40
    },
    "icon": "daggers",
    "element": "lightning",
    "elementDmg": 7,
    "tier": 4
  },
  {
    "id": "dragon_staff",
    "name": "Dragonbone Staff",
    "kind": "weapon",
    "slot": "weapon",
    "levelReq": 45,
    "value": 3000,
    "classes": ["mage"],
    "stats": {
      "ap": 78,
      "mp": 108,
      "int": 10
    },
    "icon": "staff",
    "element": "fire",
    "elementDmg": 7,
    "tier": 4
  },
  {
    "id": "dragon_mace",
    "name": "Dragon Mace",
    "kind": "weapon",
    "slot": "weapon",
    "levelReq": 45,
    "value": 3000,
    "classes": ["priest"],
    "stats": {
      "ap": 84,
      "mp": 54,
      "int": 7,
      "vit": 5
    },
    "icon": "mace",
    "element": "fire",
    "elementDmg": 7,
    "tier": 4
  },
  {
    "id": "dragon_shield",
    "name": "Dragon Shield",
    "kind": "armor",
    "slot": "offhand",
    "levelReq": 45,
    "value": 2700,
    "classes": ["warrior", "priest"],
    "stats": {
      "def": 22,
      "hp": 108,
      "vit": 5
    },
    "icon": "shield",
    "tier": 4
  },
  {
    "id": "dragon_helm",
    "name": "Dragon Helm",
    "kind": "armor",
    "slot": "head",
    "levelReq": 45,
    "value": 2100,
    "stats": {
      "def": 14,
      "hp": 68,
      "vit": 4
    },
    "icon": "helm",
    "classes": ["warrior"],
    "tier": 4
  },
  {
    "id": "dragon_plate",
    "name": "Dragon Plate",
    "kind": "armor",
    "slot": "chest",
    "levelReq": 45,
    "value": 3300,
    "stats": {
      "def": 24,
      "hp": 108,
      "vit": 5,
      "resFire": 8
    },
    "icon": "chest",
    "classes": ["warrior"],
    "tier": 4
  },
  {
    "id": "dragon_gauntlets",
    "name": "Dragon Gauntlets",
    "kind": "armor",
    "slot": "hands",
    "levelReq": 45,
    "value": 1800,
    "stats": {
      "def": 11,
      "ap": 15,
      "str": 3
    },
    "icon": "gloves",
    "classes": ["warrior"],
    "tier": 4
  },
  {
    "id": "dragon_boots",
    "name": "Dragon Boots",
    "kind": "armor",
    "slot": "feet",
    "levelReq": 45,
    "value": 1800,
    "stats": {
      "def": 11,
      "hp": 50,
      "str": 5
    },
    "icon": "boots",
    "classes": ["warrior"],
    "tier": 4
  },
  {
    "id": "hide_hood",
    "name": "Hide Hood",
    "kind": "armor",
    "slot": "head",
    "levelReq": 5,
    "value": 40,
    "classes": ["rogue"],
    "stats": {
      "def": 1,
      "hp": 8,
      "dex": 1
    },
    "icon": "hood",
    "tier": 1
  },
  {
    "id": "hide_jerkin",
    "name": "Hide Jerkin",
    "kind": "armor",
    "slot": "chest",
    "levelReq": 5,
    "value": 70,
    "classes": ["rogue"],
    "stats": {
      "def": 3,
      "hp": 12,
      "dex": 1
    },
    "icon": "jerkin",
    "tier": 1
  },
  {
    "id": "hide_grips",
    "name": "Hide Grips",
    "kind": "armor",
    "slot": "hands",
    "levelReq": 5,
    "value": 35,
    "classes": ["rogue"],
    "stats": {
      "def": 1,
      "ap": 4,
      "dex": 1
    },
    "icon": "gloves",
    "tier": 1
  },
  {
    "id": "hide_treads",
    "name": "Hide Treads",
    "kind": "armor",
    "slot": "feet",
    "levelReq": 5,
    "value": 40,
    "classes": ["rogue"],
    "stats": {
      "def": 1,
      "hp": 8,
      "dex": 1
    },
    "icon": "boots",
    "tier": 1
  },
  {
    "id": "stalker_hood",
    "name": "Stalker Hood",
    "kind": "armor",
    "slot": "head",
    "levelReq": 15,
    "value": 175,
    "classes": ["rogue"],
    "stats": {
      "def": 4,
      "hp": 19,
      "dex": 2
    },
    "icon": "hood",
    "tier": 2
  },
  {
    "id": "stalker_jerkin",
    "name": "Stalker Jerkin",
    "kind": "armor",
    "slot": "chest",
    "levelReq": 15,
    "value": 275,
    "classes": ["rogue"],
    "stats": {
      "def": 6,
      "hp": 30,
      "dex": 2
    },
    "icon": "jerkin",
    "tier": 2
  },
  {
    "id": "stalker_grips",
    "name": "Stalker Grips",
    "kind": "armor",
    "slot": "hands",
    "levelReq": 15,
    "value": 150,
    "classes": ["rogue"],
    "stats": {
      "def": 3,
      "ap": 8,
      "dex": 1
    },
    "icon": "gloves",
    "tier": 2
  },
  {
    "id": "stalker_treads",
    "name": "Stalker Treads",
    "kind": "armor",
    "slot": "feet",
    "levelReq": 15,
    "value": 150,
    "classes": ["rogue"],
    "stats": {
      "def": 3,
      "hp": 15,
      "dex": 2
    },
    "icon": "boots",
    "tier": 2
  },
  {
    "id": "nightveil_hood",
    "name": "Nightveil Hood",
    "kind": "armor",
    "slot": "head",
    "levelReq": 30,
    "value": 630,
    "classes": ["rogue"],
    "stats": {
      "def": 6,
      "hp": 33,
      "dex": 3
    },
    "icon": "hood",
    "tier": 3
  },
  {
    "id": "nightveil_jerkin",
    "name": "Nightveil Jerkin",
    "kind": "armor",
    "slot": "chest",
    "levelReq": 30,
    "value": 990,
    "classes": ["rogue"],
    "stats": {
      "def": 11,
      "hp": 52,
      "dex": 4
    },
    "icon": "jerkin",
    "tier": 3
  },
  {
    "id": "nightveil_grips",
    "name": "Nightveil Grips",
    "kind": "armor",
    "slot": "hands",
    "levelReq": 30,
    "value": 540,
    "classes": ["rogue"],
    "stats": {
      "def": 5,
      "ap": 13,
      "dex": 2
    },
    "icon": "gloves",
    "tier": 3
  },
  {
    "id": "nightveil_treads",
    "name": "Nightveil Treads",
    "kind": "armor",
    "slot": "feet",
    "levelReq": 30,
    "value": 540,
    "classes": ["rogue"],
    "stats": {
      "def": 5,
      "hp": 26,
      "dex": 4
    },
    "icon": "boots",
    "tier": 3
  },
  {
    "id": "drakescale_hood",
    "name": "Drakescale Hood",
    "kind": "armor",
    "slot": "head",
    "levelReq": 45,
    "value": 2100,
    "classes": ["rogue"],
    "stats": {
      "def": 10,
      "hp": 51,
      "dex": 4
    },
    "icon": "hood",
    "tier": 4
  },
  {
    "id": "drakescale_jerkin",
    "name": "Drakescale Jerkin",
    "kind": "armor",
    "slot": "chest",
    "levelReq": 45,
    "value": 3300,
    "classes": ["rogue"],
    "stats": {
      "def": 17,
      "hp": 81,
      "dex": 5,
      "resFire": 8
    },
    "icon": "jerkin",
    "tier": 4
  },
  {
    "id": "drakescale_grips",
    "name": "Drakescale Grips",
    "kind": "armor",
    "slot": "hands",
    "levelReq": 45,
    "value": 1800,
    "classes": ["rogue"],
    "stats": {
      "def": 8,
      "ap": 20,
      "dex": 3
    },
    "icon": "gloves",
    "tier": 4
  },
  {
    "id": "drakescale_treads",
    "name": "Drakescale Treads",
    "kind": "armor",
    "slot": "feet",
    "levelReq": 45,
    "value": 1800,
    "classes": ["rogue"],
    "stats": {
      "def": 8,
      "hp": 38,
      "dex": 5
    },
    "icon": "boots",
    "tier": 4
  },
  {
    "id": "linen_hat",
    "name": "Linen Hat",
    "kind": "armor",
    "slot": "head",
    "levelReq": 5,
    "value": 40,
    "classes": ["mage"],
    "stats": {
      "def": 1,
      "mp": 12,
      "int": 1
    },
    "icon": "hat",
    "tier": 1
  },
  {
    "id": "linen_robe",
    "name": "Linen Robe",
    "kind": "armor",
    "slot": "chest",
    "levelReq": 5,
    "value": 70,
    "classes": ["mage"],
    "stats": {
      "def": 2,
      "hp": 9,
      "mp": 16,
      "int": 1
    },
    "icon": "robe",
    "tier": 1
  },
  {
    "id": "linen_wraps",
    "name": "Linen Wraps",
    "kind": "armor",
    "slot": "hands",
    "levelReq": 5,
    "value": 35,
    "classes": ["mage"],
    "stats": {
      "def": 1,
      "ap": 4,
      "int": 1
    },
    "icon": "wraps",
    "tier": 1
  },
  {
    "id": "linen_slippers",
    "name": "Linen Slippers",
    "kind": "armor",
    "slot": "feet",
    "levelReq": 5,
    "value": 40,
    "classes": ["mage"],
    "stats": {
      "def": 1,
      "hp": 6,
      "mp": 9,
      "int": 1
    },
    "icon": "slippers",
    "tier": 1
  },
  {
    "id": "silkweave_hat",
    "name": "Silkweave Hat",
    "kind": "armor",
    "slot": "head",
    "levelReq": 15,
    "value": 175,
    "classes": ["mage"],
    "stats": {
      "def": 2,
      "mp": 24,
      "int": 2
    },
    "icon": "hat",
    "tier": 2
  },
  {
    "id": "silkweave_robe",
    "name": "Silkweave Robe",
    "kind": "armor",
    "slot": "chest",
    "levelReq": 15,
    "value": 275,
    "classes": ["mage"],
    "stats": {
      "def": 4,
      "hp": 22,
      "mp": 32,
      "int": 2
    },
    "icon": "robe",
    "tier": 2
  },
  {
    "id": "silkweave_wraps",
    "name": "Silkweave Wraps",
    "kind": "armor",
    "slot": "hands",
    "levelReq": 15,
    "value": 150,
    "classes": ["mage"],
    "stats": {
      "def": 2,
      "ap": 7,
      "int": 1
    },
    "icon": "wraps",
    "tier": 2
  },
  {
    "id": "silkweave_slippers",
    "name": "Silkweave Slippers",
    "kind": "armor",
    "slot": "feet",
    "levelReq": 15,
    "value": 150,
    "classes": ["mage"],
    "stats": {
      "def": 2,
      "hp": 11,
      "mp": 18,
      "int": 2
    },
    "icon": "slippers",
    "tier": 2
  },
  {
    "id": "moonsilk_hat",
    "name": "Moonsilk Hat",
    "kind": "armor",
    "slot": "head",
    "levelReq": 30,
    "value": 630,
    "classes": ["mage"],
    "stats": {
      "def": 4,
      "mp": 42,
      "int": 3
    },
    "icon": "hat",
    "tier": 3
  },
  {
    "id": "moonsilk_robe",
    "name": "Moonsilk Robe",
    "kind": "armor",
    "slot": "chest",
    "levelReq": 30,
    "value": 990,
    "classes": ["mage"],
    "stats": {
      "def": 7,
      "hp": 38,
      "mp": 56,
      "int": 4
    },
    "icon": "robe",
    "tier": 3
  },
  {
    "id": "moonsilk_wraps",
    "name": "Moonsilk Wraps",
    "kind": "armor",
    "slot": "hands",
    "levelReq": 30,
    "value": 540,
    "classes": ["mage"],
    "stats": {
      "def": 3,
      "ap": 12,
      "int": 2
    },
    "icon": "wraps",
    "tier": 3
  },
  {
    "id": "moonsilk_slippers",
    "name": "Moonsilk Slippers",
    "kind": "armor",
    "slot": "feet",
    "levelReq": 30,
    "value": 540,
    "classes": ["mage"],
    "stats": {
      "def": 3,
      "hp": 19,
      "mp": 32,
      "int": 3
    },
    "icon": "slippers",
    "tier": 3
  },
  {
    "id": "emberweave_hat",
    "name": "Emberweave Hat",
    "kind": "armor",
    "slot": "head",
    "levelReq": 45,
    "value": 2100,
    "classes": ["mage"],
    "stats": {
      "def": 6,
      "mp": 60,
      "int": 4
    },
    "icon": "hat",
    "tier": 4
  },
  {
    "id": "emberweave_robe",
    "name": "Emberweave Robe",
    "kind": "armor",
    "slot": "chest",
    "levelReq": 45,
    "value": 3300,
    "classes": ["mage"],
    "stats": {
      "def": 11,
      "hp": 59,
      "mp": 80,
      "int": 5,
      "resFire": 8
    },
    "icon": "robe",
    "tier": 4
  },
  {
    "id": "emberweave_wraps",
    "name": "Emberweave Wraps",
    "kind": "armor",
    "slot": "hands",
    "levelReq": 45,
    "value": 1800,
    "classes": ["mage"],
    "stats": {
      "def": 5,
      "ap": 18,
      "int": 3
    },
    "icon": "wraps",
    "tier": 4
  },
  {
    "id": "emberweave_slippers",
    "name": "Emberweave Slippers",
    "kind": "armor",
    "slot": "feet",
    "levelReq": 45,
    "value": 1800,
    "classes": ["mage"],
    "stats": {
      "def": 5,
      "hp": 28,
      "mp": 45,
      "int": 4
    },
    "icon": "slippers",
    "tier": 4
  },
  {
    "id": "acolyte_circlet",
    "name": "Acolyte Circlet",
    "kind": "armor",
    "slot": "head",
    "levelReq": 5,
    "value": 40,
    "classes": ["priest"],
    "stats": {
      "def": 2,
      "hp": 9,
      "mp": 10,
      "int": 1
    },
    "icon": "circlet",
    "tier": 1
  },
  {
    "id": "acolyte_vestment",
    "name": "Acolyte Vestment",
    "kind": "armor",
    "slot": "chest",
    "levelReq": 5,
    "value": 70,
    "classes": ["priest"],
    "stats": {
      "def": 3,
      "hp": 14,
      "mp": 8,
      "vit": 1
    },
    "icon": "vestment",
    "tier": 1
  },
  {
    "id": "acolyte_gloves",
    "name": "Acolyte Gloves",
    "kind": "armor",
    "slot": "hands",
    "levelReq": 5,
    "value": 35,
    "classes": ["priest"],
    "stats": {
      "def": 2,
      "ap": 3,
      "int": 1
    },
    "icon": "gloves",
    "tier": 1
  },
  {
    "id": "acolyte_boots",
    "name": "Acolyte Boots",
    "kind": "armor",
    "slot": "feet",
    "levelReq": 5,
    "value": 40,
    "classes": ["priest"],
    "stats": {
      "def": 2,
      "hp": 9,
      "vit": 1
    },
    "icon": "boots",
    "tier": 1
  },
  {
    "id": "cleric_circlet",
    "name": "Cleric Circlet",
    "kind": "armor",
    "slot": "head",
    "levelReq": 15,
    "value": 175,
    "classes": ["priest"],
    "stats": {
      "def": 4,
      "hp": 22,
      "mp": 20,
      "int": 1
    },
    "icon": "circlet",
    "tier": 2
  },
  {
    "id": "cleric_vestment",
    "name": "Cleric Vestment",
    "kind": "armor",
    "slot": "chest",
    "levelReq": 15,
    "value": 275,
    "classes": ["priest"],
    "stats": {
      "def": 7,
      "hp": 36,
      "mp": 16,
      "vit": 2
    },
    "icon": "vestment",
    "tier": 2
  },
  {
    "id": "cleric_gloves",
    "name": "Cleric Gloves",
    "kind": "armor",
    "slot": "hands",
    "levelReq": 15,
    "value": 150,
    "classes": ["priest"],
    "stats": {
      "def": 3,
      "ap": 6,
      "int": 1
    },
    "icon": "gloves",
    "tier": 2
  },
  {
    "id": "cleric_boots",
    "name": "Cleric Boots",
    "kind": "armor",
    "slot": "feet",
    "levelReq": 15,
    "value": 150,
    "classes": ["priest"],
    "stats": {
      "def": 3,
      "hp": 18,
      "vit": 2
    },
    "icon": "boots",
    "tier": 2
  },
  {
    "id": "sanctified_circlet",
    "name": "Sanctified Circlet",
    "kind": "armor",
    "slot": "head",
    "levelReq": 30,
    "value": 630,
    "classes": ["priest"],
    "stats": {
      "def": 7,
      "hp": 40,
      "mp": 35,
      "int": 2
    },
    "icon": "circlet",
    "tier": 3
  },
  {
    "id": "sanctified_vestment",
    "name": "Sanctified Vestment",
    "kind": "armor",
    "slot": "chest",
    "levelReq": 30,
    "value": 990,
    "classes": ["priest"],
    "stats": {
      "def": 12,
      "hp": 63,
      "mp": 28,
      "vit": 4
    },
    "icon": "vestment",
    "tier": 3
  },
  {
    "id": "sanctified_gloves",
    "name": "Sanctified Gloves",
    "kind": "armor",
    "slot": "hands",
    "levelReq": 30,
    "value": 540,
    "classes": ["priest"],
    "stats": {
      "def": 5,
      "ap": 10,
      "int": 2
    },
    "icon": "gloves",
    "tier": 3
  },
  {
    "id": "sanctified_boots",
    "name": "Sanctified Boots",
    "kind": "armor",
    "slot": "feet",
    "levelReq": 30,
    "value": 540,
    "classes": ["priest"],
    "stats": {
      "def": 5,
      "hp": 32,
      "vit": 3
    },
    "icon": "boots",
    "tier": 3
  },
  {
    "id": "dawnforged_circlet",
    "name": "Dawnforged Circlet",
    "kind": "armor",
    "slot": "head",
    "levelReq": 45,
    "value": 2100,
    "classes": ["priest"],
    "stats": {
      "def": 10,
      "hp": 61,
      "mp": 50,
      "int": 3
    },
    "icon": "circlet",
    "tier": 4
  },
  {
    "id": "dawnforged_vestment",
    "name": "Dawnforged Vestment",
    "kind": "armor",
    "slot": "chest",
    "levelReq": 45,
    "value": 3300,
    "classes": ["priest"],
    "stats": {
      "def": 18,
      "hp": 97,
      "mp": 40,
      "vit": 5,
      "resFire": 8
    },
    "icon": "vestment",
    "tier": 4
  },
  {
    "id": "dawnforged_gloves",
    "name": "Dawnforged Gloves",
    "kind": "armor",
    "slot": "hands",
    "levelReq": 45,
    "value": 1800,
    "classes": ["priest"],
    "stats": {
      "def": 8,
      "ap": 15,
      "int": 3
    },
    "icon": "gloves",
    "tier": 4
  },
  {
    "id": "dawnforged_boots",
    "name": "Dawnforged Boots",
    "kind": "armor",
    "slot": "feet",
    "levelReq": 45,
    "value": 1800,
    "classes": ["priest"],
    "stats": {
      "def": 8,
      "hp": 45,
      "vit": 4
    },
    "icon": "boots",
    "tier": 4
  },
  {
    "id": "titan_sword",
    "name": "Titan Sword",
    "kind": "weapon",
    "slot": "weapon",
    "levelReq": 55,
    "value": 7000,
    "classes": ["warrior"],
    "stats": {
      "ap": 115,
      "str": 13,
      "hp": 75
    },
    "icon": "sword",
    "tier": 5
  },
  {
    "id": "titan_greataxe",
    "name": "Titan Greataxe",
    "kind": "weapon",
    "slot": "weapon",
    "levelReq": 55,
    "value": 7000,
    "classes": ["warrior"],
    "stats": {
      "ap": 118,
      "str": 13,
      "hp": 75
    },
    "icon": "axe",
    "tier": 5,
    "twoHanded": true
  },
  {
    "id": "phantom_daggers",
    "name": "Phantom Daggers",
    "kind": "weapon",
    "slot": "weapon",
    "levelReq": 55,
    "value": 7000,
    "classes": ["rogue"],
    "stats": {
      "ap": 98,
      "dex": 13,
      "hp": 50
    },
    "icon": "daggers",
    "tier": 5
  },
  {
    "id": "astral_staff",
    "name": "Astral Staff",
    "kind": "weapon",
    "slot": "weapon",
    "levelReq": 55,
    "value": 7000,
    "classes": ["mage"],
    "stats": {
      "ap": 98,
      "mp": 135,
      "int": 13
    },
    "icon": "staff",
    "tier": 5
  },
  {
    "id": "seraphic_mace",
    "name": "Seraphic Mace",
    "kind": "weapon",
    "slot": "weapon",
    "levelReq": 55,
    "value": 7000,
    "classes": ["priest"],
    "stats": {
      "ap": 105,
      "mp": 68,
      "int": 10,
      "vit": 8
    },
    "icon": "mace",
    "tier": 5
  },
  {
    "id": "titan_shield",
    "name": "Titan Shield",
    "kind": "armor",
    "slot": "offhand",
    "levelReq": 55,
    "value": 7000,
    "classes": ["warrior", "priest"],
    "stats": {
      "def": 28,
      "hp": 135,
      "vit": 8
    },
    "icon": "shield",
    "tier": 5
  },
  {
    "id": "titan_helm",
    "name": "Titan Helm",
    "kind": "armor",
    "slot": "head",
    "levelReq": 55,
    "value": 4620,
    "classes": ["warrior"],
    "stats": {
      "def": 18,
      "hp": 87,
      "vit": 5
    },
    "icon": "helm",
    "tier": 5
  },
  {
    "id": "titan_plate",
    "name": "Titan Plate",
    "kind": "armor",
    "slot": "chest",
    "levelReq": 55,
    "value": 7260,
    "classes": ["warrior"],
    "stats": {
      "def": 31,
      "hp": 138,
      "vit": 6,
      "resShadow": 8,
      "resPoison": 8
    },
    "icon": "chest",
    "tier": 5
  },
  {
    "id": "titan_gauntlets",
    "name": "Titan Gauntlets",
    "kind": "armor",
    "slot": "hands",
    "levelReq": 55,
    "value": 3960,
    "classes": ["warrior"],
    "stats": {
      "def": 14,
      "ap": 19,
      "str": 4
    },
    "icon": "gloves",
    "tier": 5
  },
  {
    "id": "titan_boots",
    "name": "Titan Boots",
    "kind": "armor",
    "slot": "feet",
    "levelReq": 55,
    "value": 3960,
    "classes": ["warrior"],
    "stats": {
      "def": 14,
      "hp": 64,
      "str": 6
    },
    "icon": "boots",
    "tier": 5
  },
  {
    "id": "phantom_hood",
    "name": "Phantom Hood",
    "kind": "armor",
    "slot": "head",
    "levelReq": 55,
    "value": 4620,
    "classes": ["rogue"],
    "stats": {
      "def": 13,
      "hp": 65,
      "dex": 5
    },
    "icon": "hood",
    "tier": 5
  },
  {
    "id": "phantom_jerkin",
    "name": "Phantom Jerkin",
    "kind": "armor",
    "slot": "chest",
    "levelReq": 55,
    "value": 7260,
    "classes": ["rogue"],
    "stats": {
      "def": 22,
      "hp": 104,
      "dex": 6,
      "resShadow": 8,
      "resPoison": 8
    },
    "icon": "jerkin",
    "tier": 5
  },
  {
    "id": "phantom_grips",
    "name": "Phantom Grips",
    "kind": "armor",
    "slot": "hands",
    "levelReq": 55,
    "value": 3960,
    "classes": ["rogue"],
    "stats": {
      "def": 10,
      "ap": 25,
      "dex": 4
    },
    "icon": "gloves",
    "tier": 5
  },
  {
    "id": "phantom_treads",
    "name": "Phantom Treads",
    "kind": "armor",
    "slot": "feet",
    "levelReq": 55,
    "value": 3960,
    "classes": ["rogue"],
    "stats": {
      "def": 10,
      "hp": 48,
      "dex": 6
    },
    "icon": "boots",
    "tier": 5
  },
  {
    "id": "astral_hat",
    "name": "Astral Hat",
    "kind": "armor",
    "slot": "head",
    "levelReq": 55,
    "value": 4620,
    "classes": ["mage"],
    "stats": {
      "def": 8,
      "mp": 78,
      "int": 5
    },
    "icon": "hat",
    "tier": 5
  },
  {
    "id": "astral_robe",
    "name": "Astral Robe",
    "kind": "armor",
    "slot": "chest",
    "levelReq": 55,
    "value": 7260,
    "classes": ["mage"],
    "stats": {
      "def": 14,
      "hp": 76,
      "mp": 104,
      "int": 6,
      "resShadow": 8,
      "resPoison": 8
    },
    "icon": "robe",
    "tier": 5
  },
  {
    "id": "astral_wraps",
    "name": "Astral Wraps",
    "kind": "armor",
    "slot": "hands",
    "levelReq": 55,
    "value": 3960,
    "classes": ["mage"],
    "stats": {
      "def": 6,
      "ap": 23,
      "int": 4
    },
    "icon": "wraps",
    "tier": 5
  },
  {
    "id": "astral_slippers",
    "name": "Astral Slippers",
    "kind": "armor",
    "slot": "feet",
    "levelReq": 55,
    "value": 3960,
    "classes": ["mage"],
    "stats": {
      "def": 6,
      "hp": 35,
      "mp": 58,
      "int": 5
    },
    "icon": "slippers",
    "tier": 5
  },
  {
    "id": "seraphic_circlet",
    "name": "Seraphic Circlet",
    "kind": "armor",
    "slot": "head",
    "levelReq": 55,
    "value": 4620,
    "classes": ["priest"],
    "stats": {
      "def": 14,
      "hp": 78,
      "mp": 65,
      "int": 4
    },
    "icon": "circlet",
    "tier": 5
  },
  {
    "id": "seraphic_vestment",
    "name": "Seraphic Vestment",
    "kind": "armor",
    "slot": "chest",
    "levelReq": 55,
    "value": 7260,
    "classes": ["priest"],
    "stats": {
      "def": 23,
      "hp": 124,
      "mp": 52,
      "vit": 6,
      "resShadow": 8,
      "resPoison": 8
    },
    "icon": "vestment",
    "tier": 5
  },
  {
    "id": "seraphic_gloves",
    "name": "Seraphic Gloves",
    "kind": "armor",
    "slot": "hands",
    "levelReq": 55,
    "value": 3960,
    "classes": ["priest"],
    "stats": {
      "def": 10,
      "ap": 19,
      "int": 4
    },
    "icon": "gloves",
    "tier": 5
  },
  {
    "id": "seraphic_boots",
    "name": "Seraphic Boots",
    "kind": "armor",
    "slot": "feet",
    "levelReq": 55,
    "value": 3960,
    "classes": ["priest"],
    "stats": {
      "def": 10,
      "hp": 58,
      "vit": 5
    },
    "icon": "boots",
    "tier": 5
  },
  {
    "id": "silver_ring",
    "name": "Silver Ring",
    "kind": "accessory",
    "slot": "ring",
    "levelReq": 20,
    "value": 300,
    "stats": {
      "hp": 40,
      "str": 2,
      "dex": 2
    },
    "icon": "ring"
  },
  {
    "id": "moonstone_amulet",
    "name": "Moonstone Amulet",
    "kind": "accessory",
    "slot": "neck",
    "levelReq": 30,
    "value": 800,
    "stats": {
      "mp": 60,
      "int": 3,
      "hp": 30
    },
    "icon": "necklace"
  },
  {
    "id": "warlord_signet",
    "name": "Warlord's Signet",
    "kind": "accessory",
    "slot": "ring",
    "levelReq": 50,
    "value": 5000,
    "stats": {
      "hp": 160,
      "ap": 10,
      "str": 8,
      "dex": 5,
      "resWarrior": 5
    },
    "icon": "ring",
    "unique": true
  },
  {
    "id": "bear_pelt",
    "name": "Bear Pelt",
    "kind": "material",
    "slot": "none",
    "levelReq": 1,
    "value": 40,
    "stack": 20,
    "stats": {},
    "icon": "hide"
  },
  {
    "id": "troll_tusk",
    "name": "Troll Tusk",
    "kind": "material",
    "slot": "none",
    "levelReq": 1,
    "value": 70,
    "stack": 20,
    "stats": {},
    "icon": "fang"
  },
  {
    "id": "ember_core",
    "name": "Ember Core",
    "kind": "material",
    "slot": "none",
    "levelReq": 1,
    "value": 160,
    "stack": 20,
    "stats": {},
    "icon": "stone"
  },
  {
    "id": "leather_belt",
    "name": "Leather Belt",
    "kind": "accessory",
    "slot": "belt",
    "levelReq": 10,
    "value": 60,
    "stats": {
      "def": 3,
      "hp": 20,
      "vit": 1
    },
    "icon": "belt"
  },
  {
    "id": "garnet_stud",
    "name": "Garnet Stud",
    "kind": "accessory",
    "slot": "earring",
    "levelReq": 18,
    "value": 160,
    "stats": {
      "hp": 35,
      "str": 2,
      "dex": 1
    },
    "icon": "earring"
  },
  {
    "id": "iron_girdle",
    "name": "Iron Girdle",
    "kind": "accessory",
    "slot": "belt",
    "levelReq": 25,
    "value": 420,
    "stats": {
      "def": 6,
      "hp": 50,
      "vit": 2
    },
    "icon": "belt"
  },
  {
    "id": "obsidian_hoop",
    "name": "Obsidian Hoop",
    "kind": "accessory",
    "slot": "earring",
    "levelReq": 40,
    "value": 1400,
    "stats": {
      "def": 6,
      "hp": 60,
      "vit": 3,
      "str": 2
    },
    "icon": "earring"
  },
  {
    "id": "emberbound_belt",
    "name": "Emberbound Belt",
    "kind": "accessory",
    "slot": "belt",
    "levelReq": 50,
    "value": 6000,
    "stats": {
      "ap": 24,
      "str": 8,
      "hp": 120,
      "def": 6,
      "resFire": 10
    },
    "icon": "belt",
    "unique": true
  },
  {
    "id": "frostbound_belt",
    "name": "Frostbound Belt",
    "kind": "accessory",
    "slot": "belt",
    "levelReq": 50,
    "value": 6000,
    "stats": {
      "def": 18,
      "vit": 9,
      "hp": 220,
      "mp": 40,
      "resIce": 10
    },
    "icon": "belt",
    "unique": true
  },
  {
    "id": "stormbound_belt",
    "name": "Stormbound Belt",
    "kind": "accessory",
    "slot": "belt",
    "levelReq": 50,
    "value": 6000,
    "stats": {
      "ap": 18,
      "dex": 10,
      "hp": 120,
      "str": 3,
      "resLightning": 10
    },
    "icon": "belt",
    "unique": true
  },
  {
    "id": "earring_of_the_vanguard",
    "name": "Earring of the Vanguard",
    "kind": "accessory",
    "slot": "earring",
    "levelReq": 50,
    "value": 5500,
    "stats": {
      "str": 10,
      "hp": 180,
      "def": 10,
      "vit": 6,
      "ap": 6,
      "resWarrior": 4
    },
    "icon": "earring",
    "unique": true
  },
  {
    "id": "earring_of_the_shadow",
    "name": "Earring of the Shadow",
    "kind": "accessory",
    "slot": "earring",
    "levelReq": 50,
    "value": 5500,
    "stats": {
      "dex": 12,
      "ap": 20,
      "hp": 120,
      "resShadow": 10
    },
    "icon": "earring",
    "unique": true
  },
  {
    "id": "earring_of_the_arcanist",
    "name": "Earring of the Arcanist",
    "kind": "accessory",
    "slot": "earring",
    "levelReq": 50,
    "value": 5500,
    "stats": {
      "int": 12,
      "mp": 200,
      "ap": 12,
      "hp": 80
    },
    "icon": "earring",
    "unique": true
  },
  {
    "id": "earring_of_the_devout",
    "name": "Earring of the Devout",
    "kind": "accessory",
    "slot": "earring",
    "levelReq": 50,
    "value": 5500,
    "stats": {
      "int": 9,
      "vit": 9,
      "mp": 160,
      "hp": 150
    },
    "icon": "earring",
    "unique": true
  },
  {
    "id": "ashdrake_pendant",
    "name": "Ashdrake Pendant",
    "kind": "accessory",
    "slot": "neck",
    "levelReq": 55,
    "value": 8000,
    "stats": {
      "ap": 28,
      "str": 8,
      "hp": 150,
      "def": 6,
      "resFire": 12
    },
    "icon": "necklace",
    "unique": true
  },
  {
    "id": "frostdrake_pendant",
    "name": "Frostdrake Pendant",
    "kind": "accessory",
    "slot": "neck",
    "levelReq": 55,
    "value": 8000,
    "stats": {
      "def": 20,
      "vit": 9,
      "hp": 240,
      "resMage": 5,
      "resIce": 12
    },
    "icon": "necklace",
    "unique": true
  },
  {
    "id": "stormdrake_pendant",
    "name": "Stormdrake Pendant",
    "kind": "accessory",
    "slot": "neck",
    "levelReq": 55,
    "value": 8000,
    "stats": {
      "int": 12,
      "mp": 220,
      "ap": 14,
      "hp": 80,
      "resLightning": 12
    },
    "icon": "necklace",
    "unique": true
  },
  {
    "id": "bloodstone_ring",
    "name": "Bloodstone Ring",
    "kind": "accessory",
    "slot": "ring",
    "levelReq": 55,
    "value": 7500,
    "stats": {
      "ap": 22,
      "hp": 130,
      "str": 5,
      "dex": 5
    },
    "icon": "ring",
    "unique": true
  },
  {
    "id": "moonglass_ring",
    "name": "Moonglass Ring",
    "kind": "accessory",
    "slot": "ring",
    "levelReq": 55,
    "value": 7500,
    "stats": {
      "mp": 160,
      "int": 9,
      "vit": 4,
      "hp": 70,
      "resPriest": 4,
      "resShadow": 8
    },
    "icon": "ring",
    "unique": true
  },
  {
    "id": "heart_of_the_colossus",
    "name": "Heart of the Colossus",
    "kind": "accessory",
    "slot": "ring",
    "levelReq": 60,
    "value": 20000,
    "stats": {
      "hp": 400,
      "def": 24,
      "vit": 12,
      "str": 6,
      "ap": 12,
      "resWarrior": 4,
      "resRogue": 4,
      "resFire": 6,
      "resIce": 6,
      "resLightning": 6
    },
    "icon": "ring",
    "unique": true
  },
  {
    "id": "cloak_of_the_vanguard",
    "name": "Cloak of the Vanguard",
    "kind": "armor",
    "slot": "cape",
    "levelReq": 40,
    "value": 0,
    "stats": {
      "def": 6,
      "hp": 60
    },
    "icon": "cape"
  },
  {
    "id": "cloak_of_the_blooded",
    "name": "Cloak of the Blooded",
    "kind": "armor",
    "slot": "cape",
    "levelReq": 45,
    "value": 0,
    "stats": {
      "def": 10,
      "hp": 100,
      "str": 3,
      "dex": 3,
      "int": 3
    },
    "icon": "cape"
  },
  {
    "id": "cloak_of_the_champion",
    "name": "Cloak of the Champion",
    "kind": "armor",
    "slot": "cape",
    "levelReq": 50,
    "value": 0,
    "stats": {
      "def": 14,
      "hp": 150,
      "ap": 6,
      "str": 5,
      "dex": 5,
      "int": 5,
      "vit": 5
    },
    "icon": "cape"
  },
  {
    "id": "cloak_of_the_paragon",
    "name": "Cloak of the Paragon",
    "kind": "armor",
    "slot": "cape",
    "levelReq": 55,
    "value": 0,
    "stats": {
      "def": 20,
      "hp": 220,
      "mp": 60,
      "ap": 10,
      "str": 8,
      "dex": 8,
      "int": 8,
      "vit": 8
    },
    "icon": "cape"
  },
  {
    "id": "whitecrown_mantle",
    "name": "Whitecrown Mantle",
    "kind": "armor",
    "slot": "reward",
    "levelReq": 1,
    "value": 0,
    "stats": {
      "def": 40,
      "hp": 440,
      "mp": 120,
      "ap": 20,
      "str": 16,
      "dex": 16,
      "int": 16,
      "vit": 16
    },
    "icon": "mantle",
    "mantleLook": "whitecrown",
    "bound": true
  },
  {
    "id": "azure_glow",
    "retired": true,
    "name": "Azure Glow",
    "kind": "accessory",
    "slot": "glow",
    "levelReq": 40,
    "value": 0,
    "stats": {
      "int": 5,
      "mp": 120,
      "np": 5
    },
    "icon": "glow",
    "glowLook": "glow_azure"
  },
  {
    "id": "solar_glow",
    "retired": true,
    "name": "Solar Glow",
    "kind": "accessory",
    "slot": "glow",
    "levelReq": 40,
    "value": 0,
    "stats": {
      "str": 5,
      "hp": 100,
      "np": 5
    },
    "icon": "glow",
    "glowLook": "glow_solar"
  },
  {
    "id": "ember_glow",
    "retired": true,
    "name": "Ember Glow",
    "kind": "accessory",
    "slot": "glow",
    "levelReq": 40,
    "value": 0,
    "stats": {
      "dex": 5,
      "ap": 8,
      "np": 5
    },
    "icon": "glow",
    "glowLook": "glow_ember"
  },
  {
    "id": "verdant_glow",
    "retired": true,
    "name": "Verdant Glow",
    "kind": "accessory",
    "slot": "glow",
    "levelReq": 40,
    "value": 0,
    "stats": {
      "vit": 5,
      "hp": 160,
      "np": 5
    },
    "icon": "glow",
    "glowLook": "glow_verdant"
  },
  {
    "id": "violet_glow",
    "name": "Violet Glow",
    "kind": "accessory",
    "slot": "glow",
    "levelReq": 50,
    "value": 0,
    "stats": {
      "str": 4,
      "dex": 4,
      "int": 4,
      "hp": 120,
      "mp": 80,
      "np": 10
    },
    "icon": "glow",
    "glowLook": "glow_violet",
    "unique": true,
    "retired": true
  },
  {
    "id": "prism_glow",
    "name": "Prism Glow",
    "kind": "accessory",
    "slot": "glow",
    "levelReq": 55,
    "value": 0,
    "stats": {
      "str": 6,
      "dex": 6,
      "int": 6,
      "vit": 6,
      "hp": 200,
      "mp": 150,
      "np": 15
    },
    "icon": "glow",
    "glowLook": "glow_prism",
    "unique": true,
    "retired": true
  },
  {
    "id": "hellmaw_cleaver",
    "name": "Hellmaw Cleaver",
    "kind": "weapon",
    "slot": "weapon",
    "levelReq": 45,
    "value": 6000,
    "classes": ["warrior"],
    "stats": {
      "ap": 120,
      "str": 12,
      "hp": 160,
      "vit": 5,
      "def": 6
    },
    "icon": "legend_axe",
    "unique": true,
    "element": "fire",
    "elementDmg": 20,
    "twoHanded": true
  },
  {
    "id": "fangs_of_hellmaw",
    "name": "Fangs of Hellmaw",
    "kind": "weapon",
    "slot": "weapon",
    "levelReq": 45,
    "value": 6000,
    "classes": ["rogue"],
    "stats": {
      "ap": 104,
      "dex": 16,
      "str": 4,
      "hp": 100
    },
    "icon": "legend_daggers",
    "unique": true,
    "element": "fire",
    "elementDmg": 18
  },
  {
    "id": "staff_of_the_old_root",
    "name": "Staff of the Old Root",
    "kind": "weapon",
    "slot": "weapon",
    "levelReq": 45,
    "value": 6000,
    "classes": ["mage"],
    "stats": {
      "ap": 104,
      "int": 14,
      "mp": 220,
      "hp": 80
    },
    "icon": "legend_staff",
    "unique": true,
    "element": "poison",
    "elementDmg": 18
  },
  {
    "id": "hollowbell_mace",
    "name": "Hollowbell Mace",
    "kind": "weapon",
    "slot": "weapon",
    "levelReq": 45,
    "value": 6000,
    "classes": ["priest"],
    "stats": {
      "ap": 108,
      "int": 10,
      "vit": 8,
      "mp": 140,
      "hp": 100
    },
    "icon": "legend_mace",
    "unique": true,
    "element": "lightning",
    "elementDmg": 18
  },
  {
    "id": "heartsplitter",
    "name": "Nightreaper",
    "kind": "weapon",
    "slot": "weapon",
    "levelReq": 60,
    "value": 15000,
    "classes": ["warrior"],
    "stats": {
      "ap": 156,
      "str": 18,
      "hp": 240,
      "vit": 8,
      "def": 10
    },
    "icon": "legend_scythe",
    "unique": true,
    "element": "shadow",
    "elementDmg": 30,
    "twoHanded": true
  },
  {
    "id": "duskreaver_daggers",
    "name": "Duskreaver Daggers",
    "kind": "weapon",
    "slot": "weapon",
    "levelReq": 60,
    "value": 15000,
    "classes": ["rogue"],
    "stats": {
      "ap": 134,
      "dex": 22,
      "str": 6,
      "hp": 160
    },
    "icon": "legend_daggers",
    "unique": true,
    "element": "poison",
    "elementDmg": 26
  },
  {
    "id": "staff_of_the_sundered_sky",
    "name": "Staff of the Sundered Sky",
    "kind": "weapon",
    "slot": "weapon",
    "levelReq": 60,
    "value": 15000,
    "classes": ["mage"],
    "stats": {
      "ap": 134,
      "int": 20,
      "mp": 300,
      "hp": 140
    },
    "icon": "legend_staff",
    "unique": true,
    "element": "lightning",
    "elementDmg": 28
  },
  {
    "id": "crownforge_maul",
    "name": "Crownforge Maul",
    "kind": "weapon",
    "slot": "weapon",
    "levelReq": 60,
    "value": 15000,
    "classes": ["priest"],
    "stats": {
      "ap": 140,
      "int": 14,
      "vit": 12,
      "mp": 200,
      "hp": 180
    },
    "icon": "legend_mace",
    "unique": true,
    "element": "fire",
    "elementDmg": 28
  },
  {
    "id": "old_tusks_charm",
    "retired": true,
    "name": "Old Tusk's Charm",
    "kind": "accessory",
    "slot": "neck",
    "levelReq": 12,
    "value": 400,
    "stats": {
      "hp": 80,
      "ap": 6,
      "str": 3,
      "dex": 3,
      "vit": 2,
      "resPoison": 4
    },
    "icon": "necklace",
    "unique": true
  },
  {
    "id": "barrow_crown_ring",
    "name": "Barrow Crown Ring",
    "kind": "accessory",
    "slot": "ring",
    "levelReq": 28,
    "value": 1500,
    "stats": {
      "hp": 140,
      "mp": 60,
      "int": 5,
      "vit": 4,
      "resWarrior": 4,
      "resShadow": 5
    },
    "icon": "ring",
    "unique": true
  },
  {
    "id": "grave_warden_earring",
    "name": "Grave Warden Earring",
    "kind": "accessory",
    "slot": "earring",
    "levelReq": 28,
    "value": 1500,
    "stats": {
      "def": 12,
      "hp": 90,
      "vit": 5,
      "dex": 3,
      "resRogue": 4,
      "resShadow": 6
    },
    "icon": "earring",
    "unique": true
  },
  {
    "id": "mossback_hide_belt",
    "name": "Mossback Hide Belt",
    "kind": "accessory",
    "slot": "belt",
    "levelReq": 36,
    "value": 2500,
    "stats": {
      "def": 16,
      "hp": 180,
      "vit": 6,
      "str": 3,
      "resMage": 5,
      "resPoison": 10
    },
    "icon": "belt",
    "unique": true
  },
  {
    "id": "legion_belt",
    "name": "Legion Belt",
    "kind": "accessory",
    "slot": "belt",
    "levelReq": 60,
    "value": 30000,
    "stats": {
      "def": 20,
      "hp": 260,
      "vit": 8,
      "str": 4,
      "dex": 4,
      "int": 4,
      "resFire": 10,
      "resIce": 10,
      "resLightning": 10,
      "resPoison": 10,
      "resShadow": 10,
      "resWarrior": 10,
      "resRogue": 10,
      "resMage": 10,
      "resPriest": 10
    },
    "icon": "belt",
    "unique": true
  },
  {
    "id": "tyrants_ember",
    "name": "Tyrant's Ember",
    "kind": "accessory",
    "slot": "earring",
    "levelReq": 60,
    "value": 8000,
    "stats": {
      "ap": 28,
      "str": 7,
      "int": 7,
      "hp": 100,
      "resPriest": 6,
      "resFire": 8
    },
    "icon": "earring",
    "unique": true
  },
  {
    "id": "hellmaw_fang_necklace",
    "name": "Hellmaw Fang Necklace",
    "kind": "accessory",
    "slot": "neck",
    "levelReq": 60,
    "value": 8000,
    "stats": {
      "ap": 30,
      "dex": 11,
      "hp": 170,
      "str": 4,
      "resRogue": 6,
      "resFire": 10
    },
    "icon": "necklace",
    "unique": true
  },
  {
    "id": "wisp_azure",
    "name": "Azure Wisp",
    "kind": "accessory",
    "slot": "glow",
    "levelReq": 1,
    "value": 0,
    "stats": {},
    "icon": "glow",
    "glowLook": "glow_azure"
  },
  {
    "id": "wisp_solar",
    "name": "Solar Wisp",
    "kind": "accessory",
    "slot": "glow",
    "levelReq": 1,
    "value": 0,
    "stats": {},
    "icon": "glow",
    "glowLook": "glow_solar"
  },
  {
    "id": "wisp_ember",
    "name": "Ember Wisp",
    "kind": "accessory",
    "slot": "glow",
    "levelReq": 1,
    "value": 0,
    "stats": {},
    "icon": "glow",
    "glowLook": "glow_ember"
  },
  {
    "id": "wisp_verdant",
    "name": "Verdant Wisp",
    "kind": "accessory",
    "slot": "glow",
    "levelReq": 1,
    "value": 0,
    "stats": {},
    "icon": "glow",
    "glowLook": "glow_verdant"
  },
  {
    "id": "wisp_violet",
    "name": "Violet Wisp",
    "kind": "accessory",
    "slot": "glow",
    "levelReq": 1,
    "value": 0,
    "stats": {},
    "icon": "glow",
    "glowLook": "glow_violet"
  },
  {
    "id": "wisp_prism",
    "name": "Prism Wisp",
    "kind": "accessory",
    "slot": "glow",
    "levelReq": 1,
    "value": 0,
    "stats": {},
    "icon": "glow",
    "glowLook": "glow_prism"
  },
  {
    "id": "gold_bar",
    "name": "Gold Bar",
    "kind": "material",
    "slot": "none",
    "levelReq": 1,
    "value": 100000000,
    "stats": {},
    "icon": "gold_bar"
  },
  {
    "id": "riftstone_green",
    "name": "Green Riftstone",
    "kind": "material",
    "slot": "none",
    "levelReq": 1,
    "value": 30,
    "stats": {},
    "stack": 100,
    "icon": "riftstone_green"
  },
  {
    "id": "riftstone_blue",
    "name": "Blue Riftstone",
    "kind": "material",
    "slot": "none",
    "levelReq": 1,
    "value": 150,
    "stats": {},
    "stack": 100,
    "icon": "riftstone_blue"
  },
  {
    "id": "riftstone_violet",
    "name": "Violet Riftstone",
    "kind": "material",
    "slot": "none",
    "levelReq": 1,
    "value": 800,
    "stats": {},
    "stack": 100,
    "icon": "riftstone_violet"
  },
  {
    "id": "wyrmwing_cloak",
    "name": "Wyrmwing Cloak",
    "kind": "armor",
    "slot": "cape",
    "levelReq": 60,
    "value": 20000,
    "stats": {
      "def": 26,
      "hp": 320,
      "ap": 14,
      "str": 6,
      "dex": 6,
      "int": 6,
      "vit": 8,
      "np": 10,
      "resFire": 10
    },
    "unique": true,
    "icon": "cape"
  },
  {
    "id": "wings_dawnfeather",
    "name": "Dawnfeather Wings",
    "kind": "accessory",
    "slot": "wings",
    "levelReq": 1,
    "value": 0,
    "stats": {
      "xp": 10,
      "np": 10,
      "gold": 10
    },
    "icon": "wings",
    "wingLook": "wings_dawn"
  },
  {
    "id": "wings_seraph",
    "name": "Seraph Wings",
    "kind": "accessory",
    "slot": "wings",
    "levelReq": 1,
    "value": 0,
    "stats": {
      "xp": 10,
      "np": 10,
      "gold": 10
    },
    "icon": "wings",
    "wingLook": "wings_seraph"
  },
  {
    "id": "wings_sovereign",
    "name": "Sovereign Wings",
    "kind": "accessory",
    "slot": "wings",
    "levelReq": 1,
    "value": 0,
    "stats": {
      "xp": 10,
      "np": 10,
      "gold": 10
    },
    "icon": "wings",
    "wingLook": "wings_sovereign"
  },
  {
    "id": "wings_aurelian",
    "name": "Aurelian Wings",
    "kind": "accessory",
    "slot": "wings",
    "levelReq": 1,
    "value": 0,
    "stats": {
      "xp": 10,
      "np": 10,
      "gold": 10
    },
    "icon": "wings",
    "wingLook": "wings_aurelian"
  },
  {
    "id": "wings_emberdrake",
    "name": "Emberdrake Wings",
    "kind": "accessory",
    "slot": "wings",
    "levelReq": 1,
    "value": 0,
    "stats": {
      "xp": 10,
      "np": 10,
      "gold": 10
    },
    "icon": "wings",
    "wingLook": "wings_ember"
  },
  {
    "id": "wings_phoenix",
    "name": "Phoenix Wings",
    "kind": "accessory",
    "slot": "wings",
    "levelReq": 1,
    "value": 0,
    "stats": {
      "xp": 10,
      "np": 10,
      "gold": 10
    },
    "icon": "wings",
    "wingLook": "wings_phoenix"
  },
  {
    "id": "wings_nightshade",
    "name": "Nightshade Wings",
    "kind": "accessory",
    "slot": "wings",
    "levelReq": 1,
    "value": 0,
    "stats": {
      "xp": 10,
      "np": 10,
      "gold": 10
    },
    "icon": "wings",
    "wingLook": "wings_nightshade"
  },
  {
    "id": "wings_moonveil",
    "name": "Moonveil Wings",
    "kind": "accessory",
    "slot": "wings",
    "levelReq": 1,
    "value": 0,
    "stats": {
      "xp": 10,
      "np": 10,
      "gold": 10
    },
    "icon": "wings",
    "wingLook": "wings_moon"
  },
  {
    "id": "wings_frostveil",
    "name": "Frostveil Wings",
    "kind": "accessory",
    "slot": "wings",
    "levelReq": 1,
    "value": 0,
    "stats": {
      "xp": 10,
      "np": 10,
      "gold": 10
    },
    "icon": "wings",
    "wingLook": "wings_frost"
  },
  {
    "id": "mantle_lionheart",
    "name": "Lionheart Mantle",
    "kind": "accessory",
    "slot": "mantle",
    "levelReq": 1,
    "value": 0,
    "stats": {
      "xp": 10,
      "gold": 10,
      "drop": 5
    },
    "icon": "mantle",
    "mantleLook": "cloak_lionheart"
  },
  {
    "id": "mantle_starweave",
    "name": "Starweave Cloak",
    "kind": "accessory",
    "slot": "mantle",
    "levelReq": 1,
    "value": 0,
    "stats": {
      "xp": 10,
      "gold": 10,
      "drop": 5
    },
    "icon": "mantle",
    "mantleLook": "cloak_starweave"
  },
  {
    "id": "mantle_emberwake",
    "name": "Emberwake Cloak",
    "kind": "accessory",
    "slot": "mantle",
    "levelReq": 1,
    "value": 0,
    "stats": {
      "xp": 10,
      "gold": 10,
      "drop": 5
    },
    "icon": "mantle",
    "mantleLook": "cloak_emberwake"
  },
  {
    "id": "mantle_wildheart",
    "name": "Wildheart Mantle",
    "kind": "accessory",
    "slot": "mantle",
    "levelReq": 1,
    "value": 0,
    "stats": {
      "xp": 10,
      "gold": 10,
      "drop": 5
    },
    "icon": "mantle",
    "mantleLook": "cloak_wildheart"
  },
  {
    "id": "clan_cloak_banner",
    "name": "Clan Banner Cloak",
    "kind": "armor",
    "slot": "cape",
    "levelReq": 35,
    "value": 0,
    "stats": {
      "def": 8,
      "hp": 80,
      "vit": 3
    },
    "icon": "cape"
  },
  {
    "id": "clan_cloak_warden",
    "name": "Clan Warden Cloak",
    "kind": "armor",
    "slot": "cape",
    "levelReq": 45,
    "value": 0,
    "stats": {
      "def": 14,
      "hp": 150,
      "str": 4,
      "dex": 4,
      "int": 4,
      "vit": 4
    },
    "icon": "cape"
  },
  {
    "id": "clan_cloak_sovereign",
    "name": "Clan Sovereign Cloak",
    "kind": "armor",
    "slot": "cape",
    "levelReq": 55,
    "value": 0,
    "stats": {
      "def": 22,
      "hp": 240,
      "mp": 60,
      "ap": 10,
      "str": 8,
      "dex": 8,
      "int": 8,
      "vit": 8
    },
    "icon": "cape"
  },
  {
    "id": "hp_scroll",
    "name": "HP Scroll +2000",
    "kind": "consumable",
    "slot": "none",
    "levelReq": 30,
    "value": 15000,
    "stats": {},
    "stack": 20,
    "use": {
      "cooldownMs": 1000,
      "buff": {
        "stat": "maxHp",
        "value": 2000,
        "durationMs": 3600000
      }
    },
    "icon": "scroll_vigor"
  },
  {
    "id": "speed_scroll",
    "name": "Speed Scroll +55%",
    "kind": "consumable",
    "slot": "none",
    "levelReq": 30,
    "value": 10000,
    "stats": {},
    "stack": 20,
    "use": {
      "cooldownMs": 1000,
      "buff": {
        "stat": "moveSpeed",
        "value": 55,
        "pct": true,
        "durationMs": 3600000
      }
    },
    "icon": "scroll_swift"
  },
  {
    "id": "race_change_scroll",
    "name": "Scroll of the Other Banner",
    "kind": "scroll",
    "slot": "none",
    "levelReq": 1,
    "value": 2500000,
    "stats": {},
    "use": {
      "cooldownMs": 0
    },
    "change": "race",
    "icon": "scroll_banner"
  },
  {
    "id": "gender_change_scroll",
    "name": "Scroll of the Other Self",
    "kind": "scroll",
    "slot": "none",
    "levelReq": 1,
    "value": 1250000,
    "stats": {},
    "use": {
      "cooldownMs": 0
    },
    "change": "gender",
    "icon": "scroll_self"
  },
  {
    "id": "defense_scroll",
    "name": "Defense Scroll +350",
    "kind": "consumable",
    "slot": "none",
    "levelReq": 30,
    "value": 17500,
    "stats": {},
    "stack": 20,
    "use": {
      "cooldownMs": 1000,
      "buff": {
        "stat": "def",
        "value": 350,
        "durationMs": 3600000
      }
    },
    "icon": "scroll_ward"
  },
  {
    "id": "attack_scroll",
    "name": "Attack Scroll +100",
    "kind": "consumable",
    "slot": "none",
    "levelReq": 30,
    "value": 20000,
    "stats": {},
    "stack": 20,
    "use": {
      "cooldownMs": 1000,
      "buff": {
        "stat": "ap",
        "value": 100,
        "durationMs": 3600000
      }
    },
    "icon": "scroll_might"
  },
  {
    "id": "novice_xp_scroll",
    "name": "XP Scroll +30%",
    "kind": "consumable",
    "slot": "none",
    "levelReq": 1,
    "value": 0,
    "stats": {},
    "stack": 20,
    "use": {
      "cooldownMs": 1000,
      "buff": {
        "stat": "xp",
        "value": 30,
        "pct": true,
        "durationMs": 3600000
      }
    },
    "icon": "scroll_lore"
  },
  {
    "id": "novice_gold_scroll",
    "name": "Gold Scroll +10%",
    "kind": "consumable",
    "slot": "none",
    "levelReq": 1,
    "value": 0,
    "stats": {},
    "stack": 20,
    "use": {
      "cooldownMs": 1000,
      "buff": {
        "stat": "gold",
        "value": 10,
        "pct": true,
        "durationMs": 3600000
      }
    },
    "icon": "scroll_coin"
  },
  {
    "id": "novice_speed_scroll",
    "name": "Speed Scroll +55%",
    "kind": "consumable",
    "slot": "none",
    "levelReq": 1,
    "value": 0,
    "stats": {},
    "stack": 20,
    "use": {
      "cooldownMs": 1000,
      "buff": {
        "stat": "moveSpeed",
        "value": 55,
        "pct": true,
        "durationMs": 3600000
      }
    },
    "icon": "scroll_swift"
  },
  {
    "id": "novice_hp_scroll",
    "name": "HP Scroll +300",
    "kind": "consumable",
    "slot": "none",
    "levelReq": 1,
    "value": 0,
    "stats": {},
    "stack": 20,
    "use": {
      "cooldownMs": 1000,
      "buff": {
        "stat": "maxHp",
        "value": 300,
        "durationMs": 3600000
      }
    },
    "icon": "scroll_vigor"
  },
  {
    "id": "novice_defense_scroll",
    "name": "Defense Scroll +30",
    "kind": "consumable",
    "slot": "none",
    "levelReq": 1,
    "value": 0,
    "stats": {},
    "stack": 20,
    "use": {
      "cooldownMs": 1000,
      "buff": {
        "stat": "def",
        "value": 30,
        "durationMs": 3600000
      }
    },
    "icon": "scroll_ward"
  },
  {
    "id": "novice_attack_scroll",
    "name": "Attack Scroll +20",
    "kind": "consumable",
    "slot": "none",
    "levelReq": 1,
    "value": 0,
    "stats": {},
    "stack": 20,
    "use": {
      "cooldownMs": 1000,
      "buff": {
        "stat": "ap",
        "value": 20,
        "durationMs": 3600000
      }
    },
    "icon": "scroll_might"
  },
  {
    "id": "bronze_band",
    "name": "Bronze Band",
    "kind": "accessory",
    "slot": "ring",
    "levelReq": 8,
    "value": 60,
    "stats": {
      "ap": 3,
      "dex": 1
    },
    "icon": "ring"
  },
  {
    "id": "sage_charm",
    "name": "Sage's Charm",
    "kind": "accessory",
    "slot": "neck",
    "levelReq": 15,
    "value": 150,
    "stats": {
      "mp": 45,
      "int": 2,
      "def": 2
    },
    "icon": "necklace"
  },
  {
    "id": "hunters_earring",
    "name": "Hunter's Earring",
    "kind": "accessory",
    "slot": "earring",
    "levelReq": 22,
    "value": 250,
    "stats": {
      "ap": 6,
      "dex": 3,
      "hp": 20
    },
    "icon": "earring"
  },
  {
    "id": "warders_belt",
    "name": "Warder's Belt",
    "kind": "accessory",
    "slot": "belt",
    "levelReq": 32,
    "value": 600,
    "stats": {
      "def": 8,
      "hp": 70,
      "vit": 2,
      "resRogue": 2,
      "resPoison": 4
    },
    "icon": "belt"
  },
  {
    "id": "flameheart_ring",
    "name": "Flameheart Ring",
    "kind": "accessory",
    "slot": "ring",
    "levelReq": 38,
    "value": 1100,
    "stats": {
      "ap": 10,
      "str": 3,
      "int": 3,
      "hp": 40,
      "resFire": 6
    },
    "icon": "ring"
  },
  {
    "id": "stormglass_earring",
    "name": "Stormglass Earring",
    "kind": "accessory",
    "slot": "earring",
    "levelReq": 44,
    "value": 1600,
    "stats": {
      "ap": 12,
      "dex": 4,
      "mp": 40,
      "hp": 40,
      "resLightning": 6
    },
    "icon": "earring"
  },
  {
    "id": "bronze_ring_might",
    "name": "Bronze Ring of Might",
    "kind": "accessory",
    "slot": "ring",
    "levelReq": 10,
    "value": 150,
    "stats": {
      "str": 2,
      "ap": 2
    },
    "icon": "ring",
    "tier": 1
  },
  {
    "id": "bronze_ring_swift",
    "name": "Bronze Ring of Swiftness",
    "kind": "accessory",
    "slot": "ring",
    "levelReq": 10,
    "value": 150,
    "stats": {
      "dex": 2,
      "ap": 2
    },
    "icon": "ring",
    "tier": 1
  },
  {
    "id": "bronze_ring_arcane",
    "name": "Bronze Ring of the Arcane",
    "kind": "accessory",
    "slot": "ring",
    "levelReq": 10,
    "value": 150,
    "stats": {
      "int": 2,
      "mp": 20,
      "ap": 2
    },
    "icon": "ring",
    "tier": 1
  },
  {
    "id": "bronze_ring_ward",
    "name": "Bronze Ring of Warding",
    "kind": "accessory",
    "slot": "ring",
    "levelReq": 10,
    "value": 150,
    "stats": {
      "vit": 2,
      "hp": 20
    },
    "icon": "ring",
    "tier": 1
  },
  {
    "id": "bronze_neck_might",
    "name": "Bronze Amulet of Might",
    "kind": "accessory",
    "slot": "neck",
    "levelReq": 10,
    "value": 150,
    "stats": {
      "str": 2,
      "hp": 20
    },
    "icon": "necklace",
    "tier": 1
  },
  {
    "id": "bronze_neck_swift",
    "name": "Bronze Amulet of Swiftness",
    "kind": "accessory",
    "slot": "neck",
    "levelReq": 10,
    "value": 150,
    "stats": {
      "dex": 2,
      "ap": 2
    },
    "icon": "necklace",
    "tier": 1
  },
  {
    "id": "bronze_neck_arcane",
    "name": "Bronze Amulet of the Arcane",
    "kind": "accessory",
    "slot": "neck",
    "levelReq": 10,
    "value": 150,
    "stats": {
      "int": 2,
      "mp": 20
    },
    "icon": "necklace",
    "tier": 1
  },
  {
    "id": "bronze_neck_ward",
    "name": "Bronze Amulet of Warding",
    "kind": "accessory",
    "slot": "neck",
    "levelReq": 10,
    "value": 150,
    "stats": {
      "vit": 2,
      "hp": 20,
      "mp": 10
    },
    "icon": "necklace",
    "tier": 1
  },
  {
    "id": "bronze_earring_might",
    "name": "Bronze Earring of Might",
    "kind": "accessory",
    "slot": "earring",
    "levelReq": 10,
    "value": 150,
    "stats": {
      "str": 2,
      "hp": 20
    },
    "icon": "earring",
    "tier": 1
  },
  {
    "id": "bronze_earring_swift",
    "name": "Bronze Earring of Swiftness",
    "kind": "accessory",
    "slot": "earring",
    "levelReq": 10,
    "value": 150,
    "stats": {
      "dex": 2,
      "hp": 20
    },
    "icon": "earring",
    "tier": 1
  },
  {
    "id": "bronze_earring_arcane",
    "name": "Bronze Earring of the Arcane",
    "kind": "accessory",
    "slot": "earring",
    "levelReq": 10,
    "value": 150,
    "stats": {
      "int": 2,
      "mp": 20
    },
    "icon": "earring",
    "tier": 1
  },
  {
    "id": "bronze_earring_ward",
    "name": "Bronze Earring of Warding",
    "kind": "accessory",
    "slot": "earring",
    "levelReq": 10,
    "value": 150,
    "stats": {
      "vit": 2,
      "hp": 20
    },
    "icon": "earring",
    "tier": 1
  },
  {
    "id": "bronze_belt_might",
    "name": "Bronze Belt of Might",
    "kind": "accessory",
    "slot": "belt",
    "levelReq": 10,
    "value": 150,
    "stats": {
      "str": 2,
      "def": 2,
      "hp": 20
    },
    "icon": "belt",
    "tier": 1
  },
  {
    "id": "bronze_belt_swift",
    "name": "Bronze Belt of Swiftness",
    "kind": "accessory",
    "slot": "belt",
    "levelReq": 10,
    "value": 150,
    "stats": {
      "dex": 2,
      "def": 2,
      "hp": 20
    },
    "icon": "belt",
    "tier": 1
  },
  {
    "id": "bronze_belt_arcane",
    "name": "Bronze Belt of the Arcane",
    "kind": "accessory",
    "slot": "belt",
    "levelReq": 10,
    "value": 150,
    "stats": {
      "int": 2,
      "def": 2,
      "hp": 20
    },
    "icon": "belt",
    "tier": 1
  },
  {
    "id": "bronze_belt_ward",
    "name": "Bronze Belt of Warding",
    "kind": "accessory",
    "slot": "belt",
    "levelReq": 10,
    "value": 150,
    "stats": {
      "vit": 2,
      "def": 2,
      "hp": 20
    },
    "icon": "belt",
    "tier": 1
  },
  {
    "id": "silver_ring_might",
    "name": "Silver Ring of Might",
    "kind": "accessory",
    "slot": "ring",
    "levelReq": 28,
    "value": 900,
    "stats": {
      "str": 4,
      "ap": 5
    },
    "icon": "ring",
    "tier": 3
  },
  {
    "id": "silver_ring_swift",
    "name": "Silver Ring of Swiftness",
    "kind": "accessory",
    "slot": "ring",
    "levelReq": 28,
    "value": 900,
    "stats": {
      "dex": 4,
      "ap": 5
    },
    "icon": "ring",
    "tier": 3
  },
  {
    "id": "silver_ring_arcane",
    "name": "Silver Ring of the Arcane",
    "kind": "accessory",
    "slot": "ring",
    "levelReq": 28,
    "value": 900,
    "stats": {
      "int": 4,
      "mp": 45,
      "ap": 5
    },
    "icon": "ring",
    "tier": 3
  },
  {
    "id": "silver_ring_ward",
    "name": "Silver Ring of Warding",
    "kind": "accessory",
    "slot": "ring",
    "levelReq": 28,
    "value": 900,
    "stats": {
      "vit": 4,
      "hp": 45
    },
    "icon": "ring",
    "tier": 3
  },
  {
    "id": "silver_neck_might",
    "name": "Silver Amulet of Might",
    "kind": "accessory",
    "slot": "neck",
    "levelReq": 28,
    "value": 900,
    "stats": {
      "str": 4,
      "hp": 45
    },
    "icon": "necklace",
    "tier": 3
  },
  {
    "id": "silver_neck_swift",
    "name": "Silver Amulet of Swiftness",
    "kind": "accessory",
    "slot": "neck",
    "levelReq": 28,
    "value": 900,
    "stats": {
      "dex": 4,
      "ap": 5
    },
    "icon": "necklace",
    "tier": 3
  },
  {
    "id": "silver_neck_arcane",
    "name": "Silver Amulet of the Arcane",
    "kind": "accessory",
    "slot": "neck",
    "levelReq": 28,
    "value": 900,
    "stats": {
      "int": 4,
      "mp": 45
    },
    "icon": "necklace",
    "tier": 3
  },
  {
    "id": "silver_neck_ward",
    "name": "Silver Amulet of Warding",
    "kind": "accessory",
    "slot": "neck",
    "levelReq": 28,
    "value": 900,
    "stats": {
      "vit": 4,
      "hp": 45,
      "mp": 22
    },
    "icon": "necklace",
    "tier": 3
  },
  {
    "id": "silver_earring_might",
    "name": "Silver Earring of Might",
    "kind": "accessory",
    "slot": "earring",
    "levelReq": 28,
    "value": 900,
    "stats": {
      "str": 4,
      "hp": 45
    },
    "icon": "earring",
    "tier": 3
  },
  {
    "id": "silver_earring_swift",
    "name": "Silver Earring of Swiftness",
    "kind": "accessory",
    "slot": "earring",
    "levelReq": 28,
    "value": 900,
    "stats": {
      "dex": 4,
      "hp": 45
    },
    "icon": "earring",
    "tier": 3
  },
  {
    "id": "silver_earring_arcane",
    "name": "Silver Earring of the Arcane",
    "kind": "accessory",
    "slot": "earring",
    "levelReq": 28,
    "value": 900,
    "stats": {
      "int": 4,
      "mp": 45
    },
    "icon": "earring",
    "tier": 3
  },
  {
    "id": "silver_earring_ward",
    "name": "Silver Earring of Warding",
    "kind": "accessory",
    "slot": "earring",
    "levelReq": 28,
    "value": 900,
    "stats": {
      "vit": 4,
      "hp": 45
    },
    "icon": "earring",
    "tier": 3
  },
  {
    "id": "silver_belt_might",
    "name": "Silver Belt of Might",
    "kind": "accessory",
    "slot": "belt",
    "levelReq": 28,
    "value": 900,
    "stats": {
      "str": 4,
      "def": 4,
      "hp": 45
    },
    "icon": "belt",
    "tier": 3
  },
  {
    "id": "silver_belt_swift",
    "name": "Silver Belt of Swiftness",
    "kind": "accessory",
    "slot": "belt",
    "levelReq": 28,
    "value": 900,
    "stats": {
      "dex": 4,
      "def": 4,
      "hp": 45
    },
    "icon": "belt",
    "tier": 3
  },
  {
    "id": "silver_belt_arcane",
    "name": "Silver Belt of the Arcane",
    "kind": "accessory",
    "slot": "belt",
    "levelReq": 28,
    "value": 900,
    "stats": {
      "int": 4,
      "def": 4,
      "hp": 45
    },
    "icon": "belt",
    "tier": 3
  },
  {
    "id": "silver_belt_ward",
    "name": "Silver Belt of Warding",
    "kind": "accessory",
    "slot": "belt",
    "levelReq": 28,
    "value": 900,
    "stats": {
      "vit": 4,
      "def": 4,
      "hp": 45
    },
    "icon": "belt",
    "tier": 3
  },
  {
    "id": "gold_ring_might",
    "name": "Gold Ring of Might",
    "kind": "accessory",
    "slot": "ring",
    "levelReq": 48,
    "value": 3000,
    "stats": {
      "str": 6,
      "ap": 8
    },
    "icon": "ring",
    "tier": 4
  },
  {
    "id": "gold_ring_swift",
    "name": "Gold Ring of Swiftness",
    "kind": "accessory",
    "slot": "ring",
    "levelReq": 48,
    "value": 3000,
    "stats": {
      "dex": 6,
      "ap": 8
    },
    "icon": "ring",
    "tier": 4
  },
  {
    "id": "gold_ring_arcane",
    "name": "Gold Ring of the Arcane",
    "kind": "accessory",
    "slot": "ring",
    "levelReq": 48,
    "value": 3000,
    "stats": {
      "int": 6,
      "mp": 80,
      "ap": 8
    },
    "icon": "ring",
    "tier": 4
  },
  {
    "id": "gold_ring_ward",
    "name": "Gold Ring of Warding",
    "kind": "accessory",
    "slot": "ring",
    "levelReq": 48,
    "value": 3000,
    "stats": {
      "vit": 6,
      "hp": 80
    },
    "icon": "ring",
    "tier": 4
  },
  {
    "id": "gold_neck_might",
    "name": "Gold Amulet of Might",
    "kind": "accessory",
    "slot": "neck",
    "levelReq": 48,
    "value": 3000,
    "stats": {
      "str": 6,
      "hp": 80
    },
    "icon": "necklace",
    "tier": 4
  },
  {
    "id": "gold_neck_swift",
    "name": "Gold Amulet of Swiftness",
    "kind": "accessory",
    "slot": "neck",
    "levelReq": 48,
    "value": 3000,
    "stats": {
      "dex": 6,
      "ap": 8
    },
    "icon": "necklace",
    "tier": 4
  },
  {
    "id": "gold_neck_arcane",
    "name": "Gold Amulet of the Arcane",
    "kind": "accessory",
    "slot": "neck",
    "levelReq": 48,
    "value": 3000,
    "stats": {
      "int": 6,
      "mp": 80
    },
    "icon": "necklace",
    "tier": 4
  },
  {
    "id": "gold_neck_ward",
    "name": "Gold Amulet of Warding",
    "kind": "accessory",
    "slot": "neck",
    "levelReq": 48,
    "value": 3000,
    "stats": {
      "vit": 6,
      "hp": 80,
      "mp": 40
    },
    "icon": "necklace",
    "tier": 4
  },
  {
    "id": "gold_earring_might",
    "name": "Gold Earring of Might",
    "kind": "accessory",
    "slot": "earring",
    "levelReq": 48,
    "value": 3000,
    "stats": {
      "str": 6,
      "hp": 80
    },
    "icon": "earring",
    "tier": 4
  },
  {
    "id": "gold_earring_swift",
    "name": "Gold Earring of Swiftness",
    "kind": "accessory",
    "slot": "earring",
    "levelReq": 48,
    "value": 3000,
    "stats": {
      "dex": 6,
      "hp": 80
    },
    "icon": "earring",
    "tier": 4
  },
  {
    "id": "gold_earring_arcane",
    "name": "Gold Earring of the Arcane",
    "kind": "accessory",
    "slot": "earring",
    "levelReq": 48,
    "value": 3000,
    "stats": {
      "int": 6,
      "mp": 80
    },
    "icon": "earring",
    "tier": 4
  },
  {
    "id": "gold_earring_ward",
    "name": "Gold Earring of Warding",
    "kind": "accessory",
    "slot": "earring",
    "levelReq": 48,
    "value": 3000,
    "stats": {
      "vit": 6,
      "hp": 80
    },
    "icon": "earring",
    "tier": 4
  },
  {
    "id": "gold_belt_might",
    "name": "Gold Belt of Might",
    "kind": "accessory",
    "slot": "belt",
    "levelReq": 48,
    "value": 3000,
    "stats": {
      "str": 6,
      "def": 7,
      "hp": 80
    },
    "icon": "belt",
    "tier": 4
  },
  {
    "id": "gold_belt_swift",
    "name": "Gold Belt of Swiftness",
    "kind": "accessory",
    "slot": "belt",
    "levelReq": 48,
    "value": 3000,
    "stats": {
      "dex": 6,
      "def": 7,
      "hp": 80
    },
    "icon": "belt",
    "tier": 4
  },
  {
    "id": "gold_belt_arcane",
    "name": "Gold Belt of the Arcane",
    "kind": "accessory",
    "slot": "belt",
    "levelReq": 48,
    "value": 3000,
    "stats": {
      "int": 6,
      "def": 7,
      "hp": 80
    },
    "icon": "belt",
    "tier": 4
  },
  {
    "id": "gold_belt_ward",
    "name": "Gold Belt of Warding",
    "kind": "accessory",
    "slot": "belt",
    "levelReq": 48,
    "value": 3000,
    "stats": {
      "vit": 6,
      "def": 7,
      "hp": 80
    },
    "icon": "belt",
    "tier": 4
  },
  {
    "id": "riftshard_ring",
    "name": "Riftshard Ring",
    "kind": "accessory",
    "slot": "ring",
    "levelReq": 30,
    "value": 900,
    "stats": {
      "ap": 8,
      "hp": 60,
      "str": 2,
      "dex": 2,
      "int": 2,
      "resShadow": 3
    },
    "icon": "ring"
  },
  {
    "id": "riftshard_earring",
    "name": "Riftshard Earring",
    "kind": "accessory",
    "slot": "earring",
    "levelReq": 30,
    "value": 900,
    "stats": {
      "def": 6,
      "hp": 70,
      "vit": 3,
      "mp": 30
    },
    "icon": "earring"
  },
  {
    "id": "riftbound_earring",
    "name": "Riftbound Earring",
    "kind": "accessory",
    "slot": "earring",
    "levelReq": 45,
    "value": 2500,
    "stats": {
      "ap": 14,
      "hp": 100,
      "dex": 4,
      "int": 4,
      "resMage": 3,
      "resShadow": 5
    },
    "icon": "earring"
  },
  {
    "id": "riftbound_belt",
    "name": "Riftbound Belt",
    "kind": "accessory",
    "slot": "belt",
    "levelReq": 45,
    "value": 2500,
    "stats": {
      "def": 12,
      "hp": 140,
      "vit": 4,
      "str": 4,
      "resWarrior": 3
    },
    "icon": "belt"
  },
  {
    "id": "riftcrown_pendant",
    "name": "Riftcrown Pendant",
    "kind": "accessory",
    "slot": "neck",
    "levelReq": 55,
    "value": 9000,
    "stats": {
      "ap": 26,
      "hp": 200,
      "str": 6,
      "dex": 6,
      "int": 6,
      "vit": 4,
      "resWarrior": 3,
      "resRogue": 3,
      "resShadow": 10
    },
    "icon": "necklace",
    "unique": true
  },
  {
    "id": "riftwalker_cloak",
    "name": "Riftwalker Cloak",
    "kind": "armor",
    "slot": "cape",
    "levelReq": 50,
    "value": 6000,
    "stats": {
      "def": 18,
      "hp": 200,
      "ap": 10,
      "str": 5,
      "dex": 5,
      "int": 5,
      "vit": 5
    },
    "icon": "cape",
    "unique": true
  },
  {
    "id": "market_scroll",
    "name": "Market Scroll",
    "kind": "consumable",
    "slot": "none",
    "levelReq": 1,
    "value": 0,
    "stats": {},
    "opens": "market",
    "icon": "scroll_market"
  },
  {
    "id": "sapphire_coffer",
    "name": "Sapphire Coffer",
    "kind": "material",
    "slot": "none",
    "levelReq": 1,
    "value": 400,
    "stats": {},
    "stack": 100,
    "icon": "coffer_blue"
  },
  {
    "id": "jade_coffer",
    "name": "Jade Coffer",
    "kind": "material",
    "slot": "none",
    "levelReq": 1,
    "value": 120,
    "stats": {},
    "stack": 100,
    "icon": "coffer_green"
  },
  {
    "id": "greater_sapphire_coffer",
    "name": "Greater Sapphire Coffer",
    "kind": "material",
    "slot": "none",
    "levelReq": 1,
    "value": 1500,
    "stats": {},
    "stack": 100,
    "icon": "coffer_blue"
  },
  {
    "id": "greater_jade_coffer",
    "name": "Greater Jade Coffer",
    "kind": "material",
    "slot": "none",
    "levelReq": 1,
    "value": 400,
    "stats": {},
    "stack": 100,
    "icon": "coffer_green"
  }
]
